
export const defaultPrintAreas: any[] = [];


// This file might have been used to define hardcoded print areas before auto-discovery
// Restoring with basic structure to satisfy imports.
